/*
 * @Author: your name
 * @Date: 2021-05-28 20:18:01
 * @LastEditTime: 2026-03-05 17:23:32
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\main.js
 */
import Vue from 'vue';
import 'babel-polyfill';
import 'es6-promise/auto';
import * as echarts from 'echarts';
import ElementUI from 'element-ui';
import epecUi from 'epec-ui';
import _ from 'lodash';
import VueLazyLoad from 'vue-lazyload';
import VueCookies from 'vue-cookies';
import { getSubPath } from '@/modules/projectA/utils/utils';
import request from '@/modules/projectA/api/request';
import { microBaseUrl } from '@/modules/projectA/api/config';
import api from '@/modules/projectA/api/authority';
import App from './App.vue';
import router from './router/router';
import store from './store';
import resetMessage from './utils/resetMessage';
import '../../assets/css/theme/index.css';
import '../../assets/css/element-var.scss';
import directive from '../../directive';
import '../../assets/css/element-ui.scss';
import preventReClick from './utils/directive';
import '@/assets/css/iconfont/iconfont.css';
import 'viewerjs/dist/viewer.css';
import VueViewer from 'v-viewer';
import WujieVue from 'wujie-vue2';
import { EventTargetPlugin, DocElementRectPlugin } from 'wujie-polyfill';
// import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import '../../assets/css/element-variables.scss'
import '@/assets/css/icon.css';
import { getStore, setStore, removeStore } from './utils/storage';

import VueHtmlToPaper from './utils/htmlToPdf';

// 全局组件
import GL_Component from './utils/globalComponents';

console.log(store, 'store');
const { preloadApp, bus } = WujieVue; // 使用到无界API
Vue.prototype.$bus = bus;
Vue.use(WujieVue);
preloadApp({
  name: 'eav3', // 这里这个名称要和展示子应用页面设置的名称一样哦！！！！
  url: `${microBaseUrl}${getSubPath(window.location.href, 'eav3')}`, // 子应用的域名链接
  exec: true,
  props: {
    request,
  },
  plugins: [
    {
      patchElementHook(element, iframeWindow) {
        if (element.nodeName === 'STYLE') {
          element.insertAdjacentElement = function (_position, ele) {
            iframeWindow.document.head.appendChild(ele);
          };
        }
      },
    },
    {
      // 在子应用所有的css之前
      cssBeforeLoaders: [
        // 强制使子应用body定位是relative
        { content: 'body{position: relative !important}' },
      ],
    },
    {
      jsLoader: (code) => {
        // 替换popper.js内计算偏左侧偏移量
        const codes = code.replace(
          'left: elementRect.left - parentRect.left',
          'left: fixed ? elementRect.left : elementRect.left - parentRect.left'
        );
        // 替换popper.js内右侧偏移量
        return codes.replace('popper.right > data.boundaries.right', 'false');
      },
    },
    EventTargetPlugin(),
    DocElementRectPlugin(),
  ],
});

Vue.use(epecUi);
Vue.use(VueViewer);
Vue.config.productionTip = false;

Vue.use(VueLazyLoad, {
  preLoad: 1.33,
  /* error: require('~/assets/images/common/img-default-3.png'),
  loading: require('~/assets/images/common/img-default-3.png'), */
  attempt: 1,
  // throttleWait: 500,
});
Vue.filter('thousandsSeparator', function (value) {
  if (!value && value !== 0) return ''; // 如果传入的值为空或undefined，返回空字符串

  // 使用正则表达式和replace方法将数字转换为千分位格式
  return value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
});

Vue.use(VueCookies);
Vue.use(preventReClick);
Vue.use(VueHtmlToPaper);

Vue.use(GL_Component);
Vue.use(directive);
Vue.use(_);
Vue.use(ElementUI, {
  size: 'small',
});
export const eventBus = new Vue();
Vue.prototype.$message = resetMessage;
Vue.prototype.$getStore = getStore;
Vue.prototype.$setStore = setStore;
Vue.prototype.$echarts = echarts;
Vue.prototype.$removeStore = removeStore;
// 使用钩子函数对路由进行权限跳转
router.beforeEach(async (to, from, next) => {
  if (to.path === '/ssologin') {
    next();
    return;
  }
  // 获取按钮权限
  const whiteList = ['/ssologin', '/403'];
  if (!whiteList.includes(to.path) && !store?.state?.USERINFO.companyId) {
    await store.dispatch('getData_userInfo');
    await store.dispatch('get_menuList');
  }
  const menuList = store?.state?.MENULIST || [];

  if (!whiteList.includes(to.path)) {
    const res = await api.queryBackButton({ authCode: to.path });
    store.commit('button_directive', res.data);
  }
  if (!whiteList.includes(to.path)) {
    const { code, data } = await api.checkMemuAuth({ authCode: to.path });
    // console.log(res);
    if (code === '200' && !data) {
      next('/403');
      return;
    }
  }

  if (
    store.state.USERINFO.purchaseAreaFlag &&
    store.state.USERINFO.purchaseAreaCompanyId ===
    store.state.USERINFO.companyId
  ) {
    const routerFullPath = [
      {
        code: 13,
        fullPath: '/dashboard',
        name: '易专采工作台',
      },
    ];
    // console.log('to:', to);
    routerFullPath.forEach((item, index) => {
      console.log('item:', item);

      if (item.fullPath === to.fullPath) {
        store.dispatch('setPVUV', item);
      }
    });
    console.log(to);
    const params = {
      code: 301,
      fullPath: to.path,
      name: to.meta.title || to.path,
    };
    store.dispatch('setPVUV', params);
    // 这里埋点
  }

  // debugger
  // if(to.path=='/ssologin'){
  //   next();
  //   return
  // }
  // if(role==null&&token!=null){
  //   next();
  // }
  // if(role==null&&token==null){
  //   next('/ssologin');
  // }
  // console.log('to.path====>1', to.path, menuList, 11223);
  if (to.meta.isIntercept && !menuList.includes(to.path)) {
    next('/403');
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
